module.exports = __webpack_public_path__ + "img/02-6拍照上报.e2464256.svg";